import styled from 'styled-components'

const COLORS = [
  "#E5E0D7",
  "#B4F1DB",
]

type BarProps = {
  $height?: number;
  $width?: number;
  $showValue?: boolean;
}
const Bar = styled.div<BarProps>`
  height: ${({$height}) => $height || 0}%;
  width: ${({$width}) => ($width === 100) ? '100%':'calc(50% - 2px)'};
  background-color: ${({color}) => color || 'transparent'};
  position: absolute;
  bottom: 0;

  &.container {
    position: relative;
    height: 100%;
    width: 100%;
    /* border: 1px solid white; */
  }

  & > label {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
  }

  &.label::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 6px;
    background-color: #272727;
  }
`

export const ValueBar = ({maxValue=100, values}:{
  maxValue?: number;
  values: number[];
}) => {
  return (
    (maxValue === 0) ? null:
    <Bar className='container'>
    { values?.map((x:number, index:number) => (
      <Bar key={index} color={COLORS[index % 2]} $height={100 * x / maxValue}
        $width={(values.length === 1) ? 100:50}
        style={{
          left: (index === 0) ? '0':'auto',
          right: (index === 1) ? '0':'auto',
        }}
        className={(values.length === 1) ? 'label':''}
      >
      { (values.length === 1) &&
        <label>{(100 * x).toFixed(0)}%</label>
      }
      </Bar>
    ))}
    </Bar>
  )
}
